import { type RxConflictHandler } from 'rxdb';

export const lwwConflictHandler: RxConflictHandler<{ updatedAt: string }> = {
  isEqual: (a, b) => a.updatedAt === b.updatedAt,
  resolve: async (input) =>
    input.newDocumentState.updatedAt >= input.realMasterState.updatedAt
      ? input.newDocumentState
      : input.realMasterState,
};

/**
 * The only migration strategy any collection should ever declare.
 *
 * Schema changes rebuild the database rather than migrating it, so no strategy
 * can run — but RxDB's dev-mode still demands one entry per schema version.
 * See .claude/offline-schema-rebuild.md.
 */
export const identityMigration = (oldDoc: Record<string, unknown>) => ({
  ...oldDoc,
});
